import React, { useEffect } from "react";
import {
  TextField,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

import "./UserAdd.scss";
import { RestApi } from "../../../../../services/restapi.service";
import { useAppSelector } from "../../../../../redux/hooks";
import { useDispatch } from "react-redux";
import {
  actionCreateUser,
  actionGetUsers,
} from "../../../../../redux/action/user";
import { HttpState } from "../../../../../util/model";
import { useNavigate } from 'react-router';

const CreateUserSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .min(8, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  usertype: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  enabled: Yup.boolean().required(),
  alertL1: Yup.boolean().required(),
  alertL2: Yup.boolean().required(),
  minPeriod: Yup.number().required(),
  maxPower: Yup.number().required()
});

export default function UserAdd() {
  const navigate = useNavigate();
  const userCreateState = useAppSelector((state) => state.user.userCreateState);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      usertype: "moderator",
      enabled: true,
      alertL1: false,
      alertL2: false,
      minPeriod: -1,
      maxPower: -120
    },
    validationSchema: CreateUserSchema,
    onSubmit: async (values, helper) => {
      const emailResponse = await RestApi.isEmailTaken(values.email);
      if (emailResponse.data.emailtaken) {
        helper.setFieldError("email", "Email is already taken");
        return;
      }
      values.minPeriod = +values.minPeriod
      dispatch(actionCreateUser(values) as any);
    },
  });

  //useEffect(() => {
  //  dispatch(actionGetUsers() as any);
  //}, [dispatch]);
  
  useEffect(() => {
      if (userCreateState === HttpState.Success) {
        dispatch(actionGetUsers(false) as any);
        navigate("/#user"); // Updated for v6
      }
    }, [userCreateState, dispatch, navigate]);

  return (
    <div className="UserAdd">
      <Typography variant="h5">User Add</Typography>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          className="User_Add"
          name="email"
          label="Email"
          variant="outlined"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          autoComplete="off"
        />
        <TextField
          className="User_Add"
          name="password"
          label="Password"
          type="password"
          variant="outlined"
          autoComplete="off"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="enabled"
              onChange={formik.handleChange}
              checked={formik.values.enabled}
              onBlur={formik.handleBlur}
            />
          }
          label="User Enabled"
        />
        <RadioGroup
          name="usertype"
          value={formik.values.usertype}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        >
          <FormControlLabel value="user" control={<Radio />} label="User" />
          <FormControlLabel
            value="moderator"
            control={<Radio />}
            label="Moderator"
          />
          <FormControlLabel value="admin" control={<Radio />} label="Admin" />
        </RadioGroup>
        <FormControlLabel
          control={
            <Checkbox
              name="alertL1"
              onChange={formik.handleChange}
              checked={formik.values.alertL1}
              onBlur={formik.handleBlur}
            />
          }
          label="L1 Interference Alert"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="alertL2"
              onChange={formik.handleChange}
              checked={formik.values.alertL2}
              onBlur={formik.handleBlur}
            />
          }
          label="L2 Interference Alert"
        />
        <TextField
          className="User_Add"
          name="minPeriod"
          type="number"
          label="Min Period (sec) to Alert"
          variant="outlined"
          autoComplete="off"
          value={formik.values.minPeriod}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <TextField
          className="User_Add"
          name="maxPower"
          type="number"
          label="Max Power (dBm) to Alert"
          variant="outlined"
          autoComplete="off"
          value={formik.values.maxPower}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={
            !formik.isValid ||
            formik.isSubmitting ||
            userCreateState === HttpState.Progress
          }
        >
          Create a new user
        </Button>
        {userCreateState === HttpState.Failure && (
          <FormHelperText error>User creation failed</FormHelperText>
        )}
      </form>
    </div>
  );
}
